import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Navbar } from "../../commn/Navbar";

export const TeamDisplay = () => {
  const [items, setItem] = useState([]);

  const navi = new useNavigate();

  useEffect(() => {
    try {
      axios.get("/api/team/get").then((res) => {
        setItem(res.data);
      });
    } catch (err) {
      console.log(err);
    }
    console.log("node men concel beg and t");
  }, []);
  // console.log(items);

  const numAscending = [...items].sort((a, b) => a.no - b.no);
  //   console.log(numAscending);

  // delete team
  const Deleteteam = (id) => {
    axios.delete(`/api/team/delete/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("user")).token,
      },
    });
    alert("Deleted");
    navi("/Ateam");
    window.location.reload();
  };

  return (
    <div>
      <Navbar />
      <div className="mt-5" style={{ textAlign: "center" }}>
        <div className="" style={{ textAlign: "center" }}>
          <Link to={"/teamadd"}>
            <button type="button" className="btn btn-primary mt-5">
              ADD New Team Member
            </button>
          </Link>
        </div>
        <div className="mt-5">
          <h3>Our Team</h3>
          <table
            className="table shadow"
            style={{ width: "50%", marginLeft: "25%" }}
          >
            <thead>
              <tr>
                <th scope="col">No</th>
                <th scope="col">Image</th>
                <th scope="col">Name</th>
                <th scope="col">URL</th>
                <th scope="col">Details</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {numAscending.map((team) => {
                return (
                  <tr>
                    <td>{team.no}</td>
                    <td>
                      <>
                        <img
                          className=" rounded "
                          style={{ width: "50%", height: "50%" }}
                          src={"/team/" + team.image}
                        />
                      </>
                    </td>
                    <td>{team.name}</td>
                    <td>
                      <textarea className="border-0" rows="4" cols="50">
                        {team.url}
                      </textarea>
                    </td>
                    <td>
                      <textarea className="border-0" rows="4" cols="50">
                        {team.details}
                      </textarea>
                    </td>
                    <td>
                      <Link to={`/AteamUpdate/${team._id}`}>
                        <button className="btn">Update</button>
                      </Link>
                      <button
                        className="btn"
                        onClick={() => {
                          Deleteteam(team._id);
                        }}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
